import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CHANGE_PASSWORD_TRANSLATION_NAMESPACE } from 'consts';
import { EnelXGuiAtoms } from 'gui';
// import { t } from 'i18n_new';
import { ContainerChangePassword, TitelText } from 'pages/changePassword/styles';

const { Button } = EnelXGuiAtoms;

function SuccessPassword() {
  const history = useHistory();
  const { t } = useTranslation(CHANGE_PASSWORD_TRANSLATION_NAMESPACE);

  return (
    <ContainerChangePassword>
      <div className="error-wrapper">
        <TitelText Titel="titel">{t('passwordUpdated')}</TitelText>
        <div className="closeIcon icon-check" />
        <div className="error-subtext">
          <TitelText>
            {t('PasswordChangedSuccessfully')}
          </TitelText>
        </div>
        <div className="ok-btn">
          <Button
            width="30%"
            btnText={t('ok')}
            btnType="primary"
            onClick={history.goBack}
          />
        </div>
      </div>
    </ContainerChangePassword>
  );
}

export default SuccessPassword;
